import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Header } from './components/header';
import ErrorBoundary from './components/ErrorBoundary';
import { HeroSection } from './components/hero-section';
import { CartProvider } from './context/CartContext';
import { AuthProvider } from './context/AuthContext';
import { Toaster } from './components/ui/toaster';
import ScrollToTop from './components/ScrollToTop';
const AboutSection = lazy(() => import('./components/about-section'));
const ProductBasket = lazy(() => import('./components/product-basket'));
const AboutCompany = lazy(() => import('./components/about-company'));
const VideosSection = lazy(() => import('./components/videos-section'));
const BlogsSection = lazy(() => import('./components/blogs-section'));
const Footer = lazy(() => import('./components/footer'));
const WhatsAppButton = lazy(() => import('./components/whatsapp-button'));
const AboutPage = lazy(() => import('./app/about'));
const ShopPage = lazy(() => import('./app/shop'));
const CartPage = lazy(() => import('./app/cart'));
const OrdersPage = lazy(() => import('./app/orders'));
const BlogsPage = lazy(() => import('./app/blogs'));
const ContactPage = lazy(() => import('./app/contact'));
const QualityPolicyPage = lazy(() => import('./app/quality-policy'));
const BlogDetailsPage = lazy(() => import('./app/blog-details'));
const LoginPage = lazy(() => import('./app/login'));
const RegisterPage = lazy(() => import('./app/register'));
const MyAccountPage = lazy(() => import('./app/my-account'));

const TermsPage = lazy(() => import('./app/terms'));
const PrivacyPolicyPage = lazy(() => import('./app/privacy-policy'));
const DisclaimerPage = lazy(() => import('./app/disclaimer'));
const CancellationPolicyPage = lazy(() => import('./app/cancellation-policy'));
const CareerPage = lazy(() => import('./app/career'));
const ForgotPasswordPage = lazy(() => import('./app/forgot-password'));
const ResetPasswordPage = lazy(() => import('./app/reset-password'));

// HomePage component to render the main page content
function HomePage() {
  return (
    <main className="min-h-screen">
      <ErrorBoundary><Header /></ErrorBoundary>
      <ErrorBoundary><HeroSection /></ErrorBoundary>
      <Suspense fallback={<div className="p-8 text-center">Loading…</div>}>
        <ErrorBoundary><AboutSection /></ErrorBoundary>
      </Suspense>
      <Suspense fallback={<div className="p-8 text-center">Loading…</div>}>
        <ErrorBoundary><ProductBasket /></ErrorBoundary>
      </Suspense>
      <Suspense fallback={<div className="p-8 text-center">Loading…</div>}>
        <ErrorBoundary><AboutCompany /></ErrorBoundary>
      </Suspense>
      <Suspense fallback={<div className="p-8 text-center">Loading…</div>}>
        <ErrorBoundary><VideosSection /></ErrorBoundary>
      </Suspense>
      <Suspense fallback={<div className="p-8 text-center">Loading…</div>}>
        <ErrorBoundary><BlogsSection /></ErrorBoundary>
      </Suspense>
      <Suspense fallback={<div className="p-8 text-center">Loading…</div>}>
        <ErrorBoundary><Footer /></ErrorBoundary>
      </Suspense>
    </main>
  );
}

// ExternalRedirect helper removed; production build should not include localhost routes

function App() {
  return (
    <Router>
      <ScrollToTop />
      <AuthProvider>
        <CartProvider>
          <div className="App">
            <Suspense fallback={<div className="p-8 text-center">Loading…</div>}>
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/about" element={<AboutPage />} />
                <Route path="/shop" element={<ShopPage />} />
                <Route path="/cart" element={<CartPage />} />
                <Route path="/orders" element={<OrdersPage />} />
                <Route path="/blogs" element={<BlogsPage />} />
                <Route path="/blog-details" element={<BlogDetailsPage />} />
                <Route path="/contact" element={<ContactPage />} />
                <Route path="/quality-policy" element={<QualityPolicyPage />} />
                <Route path="/login" element={<LoginPage />} />

                <Route path="/register" element={<RegisterPage />} />
                <Route path="/my-account" element={<MyAccountPage />} />
                <Route path="/terms" element={<TermsPage />} />
                <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
                <Route path="/disclaimer" element={<DisclaimerPage />} />
                <Route path="/cancellation-policy" element={<CancellationPolicyPage />} />
                <Route path="/career" element={<CareerPage />} />
                <Route path="/forgot-password" element={<ForgotPasswordPage />} />
                <Route path="/reset-password" element={<ResetPasswordPage />} />
                {/* Removed localhost dev shortcuts */}
              </Routes>
            </Suspense>
            <Suspense fallback={null}>
              <ErrorBoundary><WhatsAppButton /></ErrorBoundary>
            </Suspense>
            <Toaster />
          </div>
        </CartProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;
